import React from 'react';
import Button from '@material-ui/core/Button';

class Consent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            consent: 0
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    checkBoxChangeHandler = event => {
        const checked = event.target.checked;
        this.setState({consent: checked ? 1 : 0});
    }

    render() {


        return (<div style = {{ maxWidth: 900, display: 'inline-block', textAlign: 'left' }}>
            <p style = {{ textAlign: 'center'}}>
                <strong>INFORMATION &amp; CONSENT FORM</strong>
            </p>
            <h3>Invitation to take part</h3>
            <p>
                You are being invited to test out a multi-colour picker for words,
                and&nbsp;provide feedback on its design. The&nbsp;lead researcher is Dr.
                Jennifer Mankin&nbsp;at the School of Psychology, University of Sussex;
                please email with any questions [j.mankin@sussex.ac.uk] or contact us via
                the project website.
            </p>
            <h3>Why have I been invited to contribute and what will I do?</h3>
            <p>
                We are designing an online, interactive colour picker interface to better
                represent the colours that synaesthetes experience for words. We invite you
                to try out the colour picker on words drawn randomly from a wordlist, or on
                words that you can input into the picker yourself. You can try out the
                colour picker for as long as you like. Once you've tried colouring some
                words, we will ask for your feedback on the colour picker and some
                information about your synaesthesia, which will help us improve the colour
                picker in the future.
            </p>
            <h3>What will happen to the results and my personal information?</h3>
            <p>
                We will use the data from the colour picker and the feedback that we obtain
                to make changes and improvements to the design of the colour picker. We may
                use this information to write up reports about the colour picker, including
                for publication in academic journals.
            </p>
            <h3>CONSENT&nbsp;</h3>
            <ul type="disc">
                <li>
                    I understand that by indicating my consent below, I am agreeing to take
                    part in the University of Sussex research described here, and that I have
                    read and understood this information sheet.
                    <br />
                    <br />
                </li>
                <li>
                    I understand that my participation is entirely voluntary, that I can
                    choose not to participate in part or all of the study, and that I can
                    withdraw at any stage without having to give a reason and without being
                    penalised in any way (e.g., if I am a student, my decision whether or not
                    to take part will not affect my grades).
                </li>
            </ul>
            <ul type="disc">
                <li>
                    I understand that this project will not collect any personally
                    identifiable information about me, and responses in the database will not
                    be connected to me in any way. This means that all of my responses are
                    entirely anonymous, but the project researchers will not be able to remove
                    my data from the database.
                </li>
            </ul>
            <ul type="disc">
                <li>
                    I understand that my collected data will be stored in a de-identified way
                    (e.g. using ID numbers not names), and kept separate from other details
                    about me (e.g. from the consent form). Electronic data will be stored on a
                    password-protected computer, and hard-copies will be stored behind a
                    locked door. De-identified data may be made publicly available through the
                    Open Science Framework (OSF) online data repositories or at the request of
                    other researchers.
                </li>
            </ul>
            <p>
                Once you have read and understood the information above, please tick the box
                below to confirm that you 1) are 18 years old or older and 2) consent to
                take part in this study as it has been described.
            </p>
            <p>
                <label htmlFor="consent">I consent </label>
                <input name="consent" onChange={this.checkBoxChangeHandler} required="required" type="checkbox" />
            </p>


        <Button
                    disabled={this.state.consent === 0}
                    variant="contained"
                    color="primary"
                    onClick={this.props.handlePageFinished}
                    >Continue</Button>
        </div>


    );
        }
    }

export default Consent;